// deps
import React, { memo, ReactElement } from "react";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";

// constants
import { TEXTS } from "@payment-ui/constants/index";

// styles
import { Banner, BannerCode, BannerContentContainer } from "./styles/OfferBanner.styled";

// test-ids
import { OFFER_BANNER_TEST_IDS } from "@swiggy-private/payment-test-ids";
import { getCloudinaryUrl } from "@swiggy-private/core-ui";

interface OfferBannerProps {
    offerCode: string;
}

function BannerIcon(): ReactElement {
    return (
        <img
            crossOrigin="anonymous"
            src={getCloudinaryUrl("PaymentLogos/paymentIcons/couponAppliedNew")}
            width={20}
            height={20}
        />
    );
}

function OfferBanner(props: OfferBannerProps): ReactElement {
    return (
        <Banner data-testid={OFFER_BANNER_TEST_IDS.BANNER_CONTAINER}>
            <BannerIcon />

            <BannerContentContainer>
                <Text variant="V2.body2.neutral.bold" color="positive" data-testid={OFFER_BANNER_TEST_IDS.BANNER_CODE}>
                    {props.offerCode}
                </Text>
                <BannerCode>
                    <Text
                        variant="V2.body2.neutral.medium"
                        color="positive"
                        data-testid={OFFER_BANNER_TEST_IDS.BANNER_TITLE}
                    >
                        {TEXTS.OFFER_APPLIED}
                    </Text>
                </BannerCode>
            </BannerContentContainer>
        </Banner>
    );
}

export default memo(OfferBanner);
